export default {
    list: [  
        {
            id: 1,
            name: 'Terms & Conditions',
            icon: 'person_outline',
            route: {
                name: 'client.tc.conditions',
            },
        },
        {
            id: 2,
            name: 'Policy',
            icon: 'star_border',
            route: {
                name: 'client.tc.policy',
            },
        },
    ]
}
